import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DisplayTypeService, DisplayType } from '../../../services/rest/display-type.service';
import { AuthUtils } from '../../../utils/AuthUtils';
import { PermissionTargetEnum } from '../../../enums/PermissionTargetEnum';
import { InputButtonIconType } from '../../core/button/button.utils';
import { ConfirmService } from '../../../services/confirm.service';
import { MessageService } from '../../../services/message.service';

@Component({
  selector: 'app-display-type-table',
  templateUrl: './display-type-table.component.html',
  styleUrls: ['./display-type-table.component.scss'],
})
export class DisplayTypeTableComponent implements OnInit {
  InputButtonIconType = InputButtonIconType;
  displayTypes: DisplayType[] = [];
  loading = true;
  userCanEdit: boolean = AuthUtils.canEdit(PermissionTargetEnum.DISPLAY_TYPE);

  constructor(
    private service: DisplayTypeService,
    private router: Router,
    private confirmService: ConfirmService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.service.getAll().subscribe((res) => {
      this.displayTypes = res;
      this.loading = false;
    });
  }

  onCreate(): void {
    this.router.navigate(['/display-type/create']);
  }

  onEdit(item: DisplayType): void {
    this.router.navigate(['/display-type/' + item.id]);
  }

  onDelete(item: DisplayType): void {
    this.confirmService.confirm(
      'Display-Typ löschen',
      `Wollen Sie den Display-Typ ${item.name} (${item.code}) wirklich löschen?`,
      () => {
        this.service.delete(item.id!).subscribe(() => {
          this.messageService.addSuccessMessage('Display-Typ erfolgreich gelöscht');
          this.load();
        });
      }
    );
  }
}
